import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '@shared/components/components.module';
import { SharedModule } from '@shared/shared.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TranslateModule } from '@ngx-translate/core';
import { PrivatePageComponent } from '@pages/private-pages/private-page.component';
import { PassengerChangeEditComponent } from './edit/edit.component';
import { PassengerChangeOverviewComponent } from './overview/overview.component';
import { PassengerAccordionComponent } from './passenger-accordion/passenger-accordion.component';
import { PassengerUpdateResolver } from './passenger-update.resolver';

const routes: Routes = [
  {
    path: 'passenger-change',
    component: PrivatePageComponent,
    children: [
      {
        path: 'edit',
        component: PassengerChangeEditComponent,
      },
      {
        path: 'overview',
        component: PassengerChangeOverviewComponent,
        resolve: {
          passengerUpdateData: PassengerUpdateResolver,
        },
      },
      { path: '', redirectTo: '/overview', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    ComponentsModule,
    AccordionModule.forRoot(),
    PopoverModule.forRoot(),
    TranslateModule.forChild(),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [PassengerChangeEditComponent, PassengerChangeOverviewComponent, PassengerAccordionComponent],
  bootstrap: [PassengerChangeEditComponent, PassengerChangeOverviewComponent],
})
export class PassengerChangeModule {}
